import React, { useState } from 'react';
import { CustomInputProps, Opt } from '../../models/type';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useFormContext } from 'react-hook-form';

const CustomSelect = ({ name, label, ...props }: CustomInputProps) => {

  const [value, setSelectedValue] = useState('');
  const {
    register,
    formState: { errors },
    setValue
  } = useFormContext();

  const handleChange = (event: SelectChangeEvent) => {
    const newValue:Opt = event.target.value;
    setSelectedValue(event.target.value);
    setValue(name, newValue.value);

  };
  const error = errors[name]?.message as string | undefined;

  const id = `${name}-${props.type}-${label}`;

  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label" sx={{marginTop:'-6px'}}>{label}</InputLabel>
      <Select size='small' labelId="demo-simple-select-label" value={value} id={id}  label={label} onChange={handleChange} 
      error={Boolean(errors[name])}
      >
        {props.options?.map((item) => {
          return (
            <MenuItem key={item.value} value={item}>
            {item.optionFriendlyName}
          </MenuItem>
          )
        })}
      </Select>
      <FormHelperText error={error ? true : false}>{error ? error : props.description}</FormHelperText>
    </FormControl>
  );
};

export default CustomSelect;
